<img class="size-12" src="assets/images/logos/logo-dark.svg" [alt]="'common.verified_logo.description' | translate" />
